import storesSaga from './stores.saga';

export default storesSaga;
